import InfoContext from "pages/InfoContext";
import _ from "lodash";
import moment from "moment";
import { FormattedMessage, useIntl } from "react-intl";
import { Typography } from "core/typography/Typography";
import { useContext } from "react";
import {
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LineChart,
} from "recharts";
import {
  formatSatisfactionData,
  getEquilibriumResult,
  getSatisfactionResult,
} from "utils/satisfactionHelper";
import "./SatisfactionBalance.scss";

const SatisfactionBalance = () => {
  const { filteredSatisfaction } = useContext(InfoContext);
  const intl = useIntl();

  const satisfaction_color = "#F18FBA";
  const equilibrium_color = "#33CCCC";

  const formatData = () =>
    formatSatisfactionData(filteredSatisfaction, moment().year());

  const formatTooltip = (data) => {
    const satisfactionVal = data?.payload[0]?.payload?.satisfaction;
    const equilibriumVal = data?.payload[0]?.payload?.equilibrium;
    const date = data?.payload[0]?.payload?.tooltipDate;
    return (
      <div className="hover-chart">
        <p className="title">
          {intl.formatMessage({
            id: "satisfaction_balance_title",
            defaultMessage: "Satisfaction & équilibre",
          })}
        </p>
        <p className="date">{date}</p>
        <div>
          <div className="content">
            <div className="pink-indicator " />
            {intl.formatMessage({
              id: "satisfaction_level",
              defaultMessage: "Niveau de satisfaction",
            })}
            {" : "}
            {getSatisfactionResult(satisfactionVal, intl)}
          </div>
          <div className="content">
            <div className="green-indicator " />
            {intl.formatMessage({
              id: "balance_level",
              defaultMessage: "Niveau d'équilibre",
            })}
            {" : "} {getEquilibriumResult(equilibriumVal, intl)}
          </div>
        </div>

        <br />
      </div>
    );
  };
  const formatLegend = () => (
    <div className="legend">
      <div className="content">
        <div className="pink-indicator " />
        {intl.formatMessage({
          id: "satisfaction",
          defaultMessage: "Satisfaction",
        })}
      </div>
      <div className="content">
        <div className="green-indicator" />{" "}
        {intl.formatMessage({
          id: "balance",
          defaultMessage: "Équilibre",
        })}
      </div>
    </div>
  );

  return (
    <div className="section">
      <Typography
        className="title-3 violet text-uppercase"
        type="h2"
        label={
          <FormattedMessage
            id="satisfaction_balance_title"
            defaultMessage="Satisfaction & équilibre"
          />
        }
      />
      <div>
        <LineChart width={1000} height={400} data={formatData()}>
          <CartesianGrid stroke="#f5f5f5" />
          <XAxis dataKey="date" />
          <YAxis axisLine={false} tick={false} domain={[0, 6]} />
          <Tooltip content={formatTooltip} wrapperStyle={{ width: "25%" }} />
          <Line
            type="monotone"
            stroke={satisfaction_color}
            dataKey={"satisfaction"}
            strokeWidth={3}
          />
          <Line
            type="monotone"
            stroke={equilibrium_color}
            dataKey={"equilibrium"}
            strokeWidth={3}
          />
          <Legend
            verticalAlign="middle"
            align="right"
            content={formatLegend()}
            layout="vetical"
          />
        </LineChart>
      </div>
    </div>
  );
};

export default SatisfactionBalance;
